import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
import { WaveSmallLeaderboardTopThreeDrop } from "./WaveSmallLeaderboardTopThreeDrop";
import { WaveSmallLeaderboardDefaultDrop } from "./WaveSmallLeaderboardDefaultDrop";
interface DefaultWaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: () => void;
  readonly contentPresentation?: DropContentPresentation | undefined;
  readonly isApproveWave?: boolean | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export const DefaultWaveSmallLeaderboardDrop: React.FC<DefaultWaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(10);
  const {
    drop,
    onDropClick,
    contentPresentation: t1,
    isApproveWave: t2,
    isVotingClosed: t3,
    isVotingControlsLocked: t4
  } = t0;
  const contentPresentation = t1 === undefined ? "default" : t1;
  const isApproveWave = t2 === undefined ? false : t2;
  const isVotingClosed = t3 === undefined ? false : t3;
  const isVotingControlsLocked = t4 === undefined ? false : t4;
  let t5;
  if ($[0] !== contentPresentation || $[1] !== drop || $[2] !== isApproveWave || $[3] !== isVotingClosed || $[4] !== isVotingControlsLocked || $[5] !== onDropClick) {
    t5 = !isApproveWave && typeof drop.rank === "number" && drop.rank <= 3 ? <WaveSmallLeaderboardTopThreeDrop drop={drop} onDropClick={onDropClick} contentPresentation={contentPresentation} /> : <WaveSmallLeaderboardDefaultDrop drop={drop} onDropClick={onDropClick} contentPresentation={contentPresentation} isApproveWave={isApproveWave} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} />;
    $[0] = contentPresentation;
    $[1] = drop;
    $[2] = isApproveWave;
    $[3] = isVotingClosed;
    $[4] = isVotingControlsLocked;
    $[5] = onDropClick;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onDropClick || $[8] !== t5) {
    t6 = <div className="tw-cursor-pointer" onClick={onDropClick}>{t5}</div>;
    $[7] = onDropClick;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};